import { render, staticRenderFns } from "./SatellitePage.vue?vue&type=template&id=0669f67e&scoped=true"
import script from "./SatellitePage.vue?vue&type=script&lang=js"
export * from "./SatellitePage.vue?vue&type=script&lang=js"
import style0 from "./SatellitePage.vue?vue&type=style&index=0&id=0669f67e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0669f67e",
  null
  
)

export default component.exports